module.exports = __webpack_public_path__ + "img/signon_logo10.1a.a3be04aa.png";